import {createAsyncThunk} from '@reduxjs/toolkit';

interface EntityFactory<EntityType> {
  (data: any): EntityType;
}

interface CreateEntityThunksOptions {
  activate?: boolean;
  deactivate?: boolean;
}

export function createEntityThunks<EntityType>(
  entityName: string,
  service: any,
  options?: CreateEntityThunksOptions,
  entityFactory?: EntityFactory<EntityType>,
) {
  class EntityThunks {
    static create = createAsyncThunk(
      `${entityName}/create`,
      async (data: any) => {
        console.log('create', data)
        try {
          return await service.create(data);
        } catch (error) {
          console.log(error)
          throw error;
        }
      },
    );

    static index = createAsyncThunk(
      `${entityName}/index`,
      async ({
        page,
        search,
        sortField,
        sortDirection,
        rowsPerPage,
      }: {
        page?: number;
        search?: any;
        sortField?: string;
        sortDirection?: string;
        rowsPerPage?: number;
      } = {}) => {
        return await service.index(
          page,
          search,
          sortField,
          sortDirection,
          rowsPerPage,
        );
      },
    );

    static show = createAsyncThunk(
      `${entityName}/fetchById`,
      async (id: string) => {
        return await service.show(id);
      },
    );

    static update = createAsyncThunk(
      `${entityName}/update`,
      async (data: any) => {
        return await service.update(data);
      },
    );

    static delete = createAsyncThunk(
      `${entityName}/delete`,
      async (id: string) => {
        return await service.delete(id);
      },
    );

    static activate = createAsyncThunk(
      `${entityName}/activate`,
      async (input: string | number | {id: string | number; silent?: boolean}) => {
        if (!options?.activate) {
          throw new Error(`Activate not implemented for ${entityName}`);
        }
        const id = typeof input === 'string' || typeof input === 'number' ? String(input) : String(input.id);
        const silent = typeof input === 'object' ? input.silent || false : false;
        const data = entityFactory
          ? entityFactory({id, status: 'active'})
          : {id, status: 'active'};
        const result = await service.update(data);
        return {result, silent};
      },
    );

    static deactivate = createAsyncThunk(
      `${entityName}/deactivate`,
      async (input: string | number | {id: string | number; silent?: boolean}) => {
        if (!options?.deactivate) {
          throw new Error(`Deactivate not implemented for ${entityName}`);
        }
        const id = typeof input === 'string' || typeof input === 'number' ? String(input) : String(input.id);
        const silent = typeof input === 'object' ? input.silent || false : false;
        const data = entityFactory
          ? entityFactory({id, status: 'inactive'})
          : {id, status: 'inactive'};
        const result = await service.update(data);
        return {result, silent};
      },
    );
    static upsert = createAsyncThunk(
      `${entityName}/upsert`,
      async (data: any) => {
        if (data.id) {
          console.log('updating');
          return this.update(data);
        } else {
          console.log('creating');
          console.log(data)
          return this.create(data);
        }
      },
    );
  }

  return EntityThunks;
}
